import PropTypes from 'prop-types'

/** The design's darker check, used wherever the glyph sits on a light background. */
export const CHECK_GREEN = '#4f793a'

/**
 * Filled success check from the design system: a light green disc with a tick.
 *
 * The disc is a fixed status color. The tick is white in the source asset, which is what the
 * desktop modal uses, but the mobile screens draw the same component with a darker green tick —
 * hence the prop. Geometry is in viewBox units, so scaling the svg scales the stroke with it:
 * rendered at 50 this reproduces the mobile design's 40px disc and 3px stroke exactly.
 *
 * @param {object} props
 * @param {string} [props.checkColor]
 */
function CircleCheckFilled({ checkColor = '#ffffff', ...props }) {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 30 30'
      width='30'
      height='30'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <circle fill='#b8d6a9' cx='15' cy='15' r='12' />
      <path
        d='m9.333 14.751 4.212 4.916 6.788-10'
        fill='none'
        stroke={checkColor}
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

CircleCheckFilled.propTypes = {
  checkColor: PropTypes.string,
}

export default CircleCheckFilled
